import React from 'react';
import { Error404 } from '@/components/custom/error';

export const NotFound = () => {
  return <Error404 />;
};
